export const absInt = string => Math.abs( parseInt( string, 10 ) );
